<table
	class="failed-transactions table"
	mat-table
	[dataSource]="dataSourceFailedTransactions"
	multiTemplateDataRows
	matSort
>
	<tr mat-header-row *matHeaderRowDef="customerColumns"></tr>
	<tr
		mat-row
		*matRowDef="let element; columns: customerColumns"
		#customerRow
		(click)="toggleRow(element)"
		[ngClass]="{ expanded: isExpanded(element), collapsed: !isExpanded(element) }"
	></tr>
	<tr mat-row *matRowDef="let row; columns: ['expandedDetail']"></tr>

	<!--First Layer-->
	<ng-container class="table-container">
		<ng-container matColumnDef="Customers">
			<th mat-header-cell *matHeaderCellDef>Customers</th>
			<td mat-cell class="customer-data customerName first-collumn" *matCellDef="let element">
				<span
					[matTooltip]="element.customerDetails.name"
					[matTooltipPosition]="'above'"
					[matTooltipClass]="'tooltip-failedTrans'"
					class="text"
					>{{ element.customerDetails.name }}</span
				>
			</td>
		</ng-container>

		<ng-container matColumnDef="Paygroups">
			<th mat-header-cell *matHeaderCellDef>Paygroups</th>
			<td class="customer-data paygroupCount second-collumn" mat-cell *matCellDef="let element">
				<span class="text" *ngIf="element.payGroupCount > 1">{{ element.payGroupCount }} Paygroups</span>
				<span class="text" *ngIf="element.payGroupCount < 2">{{ element.payGroupCount }} Paygroup</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="Paycycles">
			<th mat-header-cell *matHeaderCellDef>Paycycles</th>
			<td class="customer-data payCycleCount third-collumn" mat-cell *matCellDef="let element">
				<span class="text" *ngIf="element.payCycleCount > 1">{{ element.payCycleCount }} Paycycles</span>
				<span class="text" *ngIf="element.payCycleCount < 2">{{ element.payCycleCount }} Paycycle</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="Payments">
			<th mat-header-cell *matHeaderCellDef>Payments</th>
			<td class="customer-data payment-count fourth-collumn" mat-cell *matCellDef="let element">
				<span class="text" *ngIf="element.paymentCount > 1">{{ element.paymentCount }} Payments</span>
				<span class="text" *ngIf="element.paymentCount < 2">{{ element.paymentCount }} Payment</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="Transactions">
			<th mat-header-cell *matHeaderCellDef>Transactions</th>
			<td class="customer-data missing-bank-count fifth-collumn" mat-cell *matCellDef="let element">
				<span class="text" *ngIf="element.totalTransactionCount > 1"
					>{{ element.totalTransactionCount }} Failed Transactions</span
				>
				<span class="text" *ngIf="element.totalTransactionCount < 2"
					>{{ element.totalTransactionCount }} Failed Transaction</span
				>
			</td>
		</ng-container>

		<ng-container matColumnDef="expand">
			<th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
			<td mat-cell *matCellDef="let element" class="button-container customer-data sixth-collumn">
				<button
					#expand
					mat-icon-button
					class="drop-down-arrow-button"
					aria-label="expand row"
					(click)="toggleRow(element); $event.stopPropagation()"
					element="element"
				>
					<app-icon
						class="drop-down-arrow"
						[ngClass]="{ down: isExpanded(element) }"
						[name]="'arrow-down'"
						[size]="'18px'"
						[lineWidth]="'2.5px'"
					></app-icon>
				</button>
			</td>
		</ng-container>
	</ng-container>

	<!--Second Layer-->
	<ng-container class="paygroup-container" matColumnDef="expandedDetail">
		<td
			mat-cell
			*matCellDef="let element"
			class="paygroup-row"
			[ngClass]="{
				'paygroups-expanded': isExpanded(element)
			}"
			[attr.colspan]="paygroupsColumns.length"
		>
			<div class="paygroup-detail" *ngIf="element.payGroups.length" [@detailExpand]="expandedState(element)">
				<div class="inner-table">
					<table
						class="paygroup-table"
						#innerTables
						mat-table
						[dataSource]="element.payGroups"
						multiTemplateDataRows
						matSort
					>
						<ng-container matColumnDef="first-padding">
							<th class="hide" mat-header-cell *matHeaderCellDef></th>
							<td class="padding first-collumn" mat-cell *matCellDef="let element">
								<span class="first padding text">{{ element.payGroupDetails.name }}</span>
							</td>
						</ng-container>

						<ng-container matColumnDef="Paygroups">
							<th class="hide" mat-header-cell *matHeaderCellDef></th>
							<td class="paygroup-data paygroupName second-collumn" mat-cell *matCellDef="let element">
								<span
									class="payGroup-name text"
									[matTooltip]="
										element.legalEntityExternalId +
										' ' +
										element.payGroupDetails.name +
										' ' +
										element.payGroupDetails.externalId
									"
									[matTooltipPosition]="'above'"
									[matTooltipClass]="'tooltip-failedTrans'"
								>
									<img
										src="assets/svg-country-flags/svg/{{
											element.payGroupDetails.country?.toLowerCase()
										}}.svg"
									/>

									{{ element.legalEntityExternalId }} {{ element.payGroupDetails.name }}
									{{ element.payGroupDetails.externalId }}</span
								>
							</td>
						</ng-container>

						<ng-container matColumnDef="Paycycles">
							<th class="hide" mat-header-cell *matHeaderCellDef></th>
							<td class="paygroup-data third-collumn" mat-cell *matCellDef="let element">
								<span
									class="text"
									[matTooltip]="element.payCycleDetails.name"
									[matTooltipPosition]="'above'"
									[matTooltipClass]="'tooltip-failedTrans'"
									>{{ element.payCycleDetails.name }}</span
								>
							</td>
						</ng-container>

						<ng-container matColumnDef="Group">
							<th class="hide" mat-header-cell *matHeaderCellDef></th>
							<td class="paygroup-data fourth-collumn" mat-cell *matCellDef="let element">
								<div class="group-container">
									<span class="group text">{{ element.milestoneDetails.group }}</span>
								</div>
							</td>
						</ng-container>

						<ng-container matColumnDef="Transactions">
							<th class="hide" mat-header-cell *matHeaderCellDef></th>
							<td
								class="paygroup-data failed-transaction-count fifth-collumn"
								mat-cell
								*matCellDef="let element"
							>
								<span class="text" *ngIf="element.transactionCount > 1"
									>{{ element.transactionCount }} Failed Transactions</span
								>
								<span class="text" *ngIf="element.transactionCount < 2"
									>{{ element.transactionCount }} Failed Transaction</span
								>
							</td>
						</ng-container>

						<ng-container matColumnDef="second-padding">
							<th class="hide" mat-header-cell *matHeaderCellDef></th>
							<td mat-cell *matCellDef="let element" class="padding sixth-collumn">
								<button class="padding">
									<app-icon
										class="drop-down-arrow"
										[ngClass]="{ down: isExpanded(element) }"
										[name]="'arrow-down'"
									></app-icon>
								</button>
							</td>
						</ng-container>

						<tr mat-header-row *matHeaderRowDef="paygroupsColumns"></tr>
						<tr
							mat-row
							*matRowDef="let row; columns: paygroupsColumns"
							(click)="routeToFailedTransations(row)"
						></tr>
					</table>
				</div>
			</div>
		</td>
	</ng-container>
</table>
